import { Box, Typography } from '@mui/material';
import parse from 'html-react-parser';
import { forwardRef, PropsWithChildren, ForwardedRef } from 'react';
import { Trans } from 'react-i18next';

import { PrintLayoutProps } from './PrintLayout.types';

const PrintLayout = forwardRef<HTMLDivElement, PrintLayoutProps>(
  Object.assign(
    (
      props: PropsWithChildren<PrintLayoutProps>,
      ref: ForwardedRef<HTMLDivElement>
    ) => {
      /** PROPS */
      const { printData, show } = props;
      const { name = '', listType = '', isDefault, body, subject } = printData;

      /** CONTENT BODY */
      const htmlBody = parse(body || '');

      return (
        <Box display={!show ? 'none' : 'initial'}>
          <Box ref={ref} padding="4.5rem 4.5rem 4.5rem 7.5rem">
            <Typography variant="tableHeader" sx={{ mb: 1.5 }}>
              <Trans
                i18nKey={
                  subject
                    ? 'common.messages.Email Name'
                    : 'common.messages.Script Name'
                }
              />
              <Typography component="span" variant="main">
                {`: ${name}`}
              </Typography>
            </Typography>
            <Box display="flex" alignItems="center" mb={1.5}>
              <Typography variant="tableHeader" minWidth="16.7rem">
                <Trans i18nKey="common.table.List Type" />
                <Typography component="span" variant="main">
                  {`: ${listType}`}
                </Typography>
              </Typography>
              <Typography variant="tableHeader" sx={{ ml: 1.5 }}>
                <Trans i18nKey="common.table.Default" />
                <Typography component="span" variant="main">
                  {`: ${isDefault ? 'Yes' : 'No'}`}
                </Typography>
              </Typography>
            </Box>
            {subject && (
              <Typography variant="tableHeader">
                <Trans i18nKey="Email.Email Subject" />
                <Typography component="span" variant="main">
                  {`: ${subject}`}
                </Typography>
              </Typography>
            )}
            <Box
              mt={4.5}
              sx={{ fontSize: ({ typography }) => typography.main.fontSize }}
            >
              {htmlBody}
            </Box>
          </Box>
        </Box>
      );
    },
    { displayName: 'PrintLayout' }
  )
);

export default PrintLayout;
